import React from 'react';
import { getHeading } from '../../../common/search/realestate';
import type { RealestateAd, RealestateProjectAd } from '../../../types';
import { useSearchAdContext } from '../SearchAdContext';
import type { SearchAdHeadingProps } from '../SearchAdHeading';
import { SearchAdHeading } from '../SearchAdHeading';

type RealestateHeadingProps = {
    ad: RealestateAd | RealestateProjectAd;
    className?: string;
    heading?: (props: SearchAdHeadingProps) => React.ReactElement | null;
    isLettingsOrLettingsWanted?: boolean;
};

export function RealestateHeading(props: RealestateHeadingProps) {
    const { ad, className = '', heading, isLettingsOrLettingsWanted } = props;

    const { mode } = useSearchAdContext();

    const headingClass = `${className} ${
        mode === 'mobile' ? '' : 'sf-realestate-heading'
    }`;

    const headingText = getHeading(ad, isLettingsOrLettingsWanted);

    return heading ? (
        heading({ className: headingClass })
    ) : (
        <SearchAdHeading className={headingClass}>
            {headingText}
        </SearchAdHeading>
    );
}
